import { render, staticRenderFns } from "./UniversalGemsDisplay.vue?vue&type=template&id=50be9a87&scoped=true"
import script from "./UniversalGemsDisplay.vue?vue&type=script&lang=ts"
export * from "./UniversalGemsDisplay.vue?vue&type=script&lang=ts"
import style0 from "./UniversalGemsDisplay.vue?vue&type=style&index=0&id=50be9a87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be9a87",
  null
  
)

export default component.exports